import { Component } from '@angular/core';
import {
  CompanyResponse,
  UserEntityRelationWithoutUserDataResponse,
  UserResponse
} from '../../@shared/models/response.module';
import {StorageService} from '../../@core/services/storage.service';
import {CompanyService} from '../../@shared/services/company.service';
import {COR_COY_0} from '../../@shared/models/input.module';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {EditCompanyImages} from './components/company-profile-overview/components/edit-company-images/edit-company-images';
import {UpdateCompanyImage} from './components/update-company-image/update-company-image';

@Component({
  selector: 'app-company-profile',
  standalone: false,
  templateUrl: './company-profile.html',
  styleUrl: './company-profile.css'
})
export class CompanyProfile {
  user: UserResponse
  selectedCompany: UserEntityRelationWithoutUserDataResponse
  company: CompanyResponse
  selectedTab: string = 'information'


  constructor(private storageService: StorageService,
              private companyService: CompanyService,
              private modalService: NgbModal) {
  }

  ngOnInit() {
    this.selectedCompany = this.storageService.getSelectedCompany()
    this.getCompany();
  }

  getCompany() {
    let params: COR_COY_0 = {
      company_id: this.selectedCompany.entity_id
    }

    this.companyService.getCompanyById(params).subscribe((res) => {
      this.company = res;
      console.log("Company Data: ", this.company);
    })
  }

  openUpdateLogoModal() {
    let modalRef = this.modalService.open(EditCompanyImages, {centered: true, size: 'lg'});
    modalRef.componentInstance.company = this.company;
    modalRef.result.then((result) => {
      if (result) {
        this.getCompany();
      }
    }).catch(() => {});
  }

  openUpdateImageModal(imageType: 'header' | 'logo') {
    let modalRef = this.modalService.open(UpdateCompanyImage, {centered: true, size: 'md'});
    modalRef.componentInstance.company = this.company;
    modalRef.componentInstance.imageType = imageType;
    modalRef.result.then((result) => {
      if (result) {
        this.getCompany();
      }
    }).catch(() => {});
  }

}
